import axios from 'axios';

import {
  API_CONSOLIDATION_EXPORT_CSV,
  API_CONSOLIDATION_EXPORT_EXCEL,
  API_CONSOLIDATION_EXPORT_PDF,
  API_CONSOLIDATION_EXPORT_PDF_DETAIL,
  API_CONSOLIDATION_SAVE_V2,
} from '../../const/Api';
import {QUESTION_TYPE} from '../../const/dataEnum';
import consolidationApi from '../../api/rest/consolidationApi';
import {showAlert} from '../../lib/utilities';

const callApiSaveConsolidation = async (data, authToken) => {
  try {
    const response = await axios.post(API_CONSOLIDATION_SAVE_V2, data, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return response;
  } catch (error) {
    console.error('callApiSaveConsolidation error: ', error.message);
    return null;
  }
};

export const callApiExportCSV = async (data, authToken, isExportRaw) => {
  try {
    const response = await axios.get(
      `${API_CONSOLIDATION_EXPORT_CSV}/${data.employeeId}/${data.periodId}?raw=${isExportRaw}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    console.log('callApiExportExcel', response);
    return response;
  } catch (error) {
    console.error('callApiExportExcel error: ', error.message);
    return null;
  }
};

const callApiExportExcel = async (data, authToken, isExportRaw) => {
  try {
    const response = await axios.get(
      `${API_CONSOLIDATION_EXPORT_EXCEL}/${data.employeeId}/${data.periodId}?raw=${isExportRaw}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    console.log('callApiExportExcel', response);
    return response;
  } catch (error) {
    console.error('callApiExportExcel error: ', error.message);
    return null;
  }
};

const callApiExportPdf = async (data, authToken) => {
  try {
    const response = await axios.get(
      `${API_CONSOLIDATION_EXPORT_PDF}/${data.employeeId}/${data.periodId}/${data.authRoleID}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    console.log('callApiExpcallApiExportPdfortExcel', response);
    return response;
  } catch (error) {
    console.error('callApiExportPdf error: ', error.message);
    return null;
  }
};

const callApiExportPdfDetail = async (data, authToken, userAuthRoleId) => {
  try {
    const response = await axios.get(
      `${API_CONSOLIDATION_EXPORT_PDF_DETAIL}/${data.employeeId}/${data.periodId}/${data.authRoleID}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    console.log('callApiExpcallApiExportPdfortExcel', response);
    return response;
  } catch (error) {
    console.error('callApiExportPdf error: ', error.message);
    return null;
  }
};

export const saveConsolidation = (state, authToken, userId, projectId, release) => async (dispatch) => {
  const params = {
    currentUserId: userId,
    employeeId: Number(state.employeeId),
    periodId: Number(state.periodId),
    projectId: Number(projectId),
    release,
    generalReviews: state.generalReviews
      .filter((gr) => gr.questionType !== QUESTION_TYPE.ESSAY)
      .map((r) => ({
        questionId: r.questionId,
        questionTitle: r.questionTitle,
        questionType: r.questionType,
        finalScore: r.scoreConsolidation,
        subTotal: r.subTotalConsolidation,
      })),
    skillReviews: state.skillReviews
      .filter((gr) => gr.questionType !== QUESTION_TYPE.ESSAY)
      .map((s) => ({
        questionId: s.questionId,
        questionType: s.questionType,
        questionTitle: s.questionTitle,
        finalScore: s.scoreConsolidation,
        subTotal: s.subTotalConsolidation,
      })),
  };
  const response = await callApiSaveConsolidation(params, authToken);

  let successMessage = 'Consolidation has been successfully saved';
  let errorMessage = 'Failed to save consolidation';

  if (release) {
    successMessage = 'Successfully save and lock consolidation';
    errorMessage = 'Failed to save and lock consolidation';
  }

  dispatch(showAlert(response, successMessage, errorMessage));

  if (!response) return null;
  return response.data;
};

export const getConsolidationScore = (reviewPeriodId) => async (dispatch) => {
  const response = await consolidationApi.getFinalScore(reviewPeriodId);
  if (!response) return null;
  return response;
};

const generateProgress = (questionType, score) => {
  let max = 0;

  if (!score) return null;
  switch (questionType) {
    case QUESTION_TYPE.SCORE_5: {
      max = 5;
      return (score / max) * 100;
    }
    case QUESTION_TYPE.SCORE_10: {
      max = 10;
      return (score / max) * 100;
    }
    case QUESTION_TYPE.SCORE_20: {
      max = 20;
      return (score / max) * 100;
    }
    default:
      return 0;
  }
};

const generateVariant = (progress) => {
  if (progress < 30) {
    return 'warning';
  }

  if (progress < 80) {
    return 'info';
  }

  return 'success';
};

export const generateGeneralReview = (data) => {
  if (!data?.employeeGenericReviews) return [];
  const generalReviews = data.employeeGenericReviews.map((gr) => ({
    id: gr.genericReviewQuestion.id,
    title: gr.question,
    score: gr.score,
    progress: generateProgress(gr.genericReviewQuestion.questionType, gr.score),
    variant: generateVariant(generateProgress(gr.genericReviewQuestion.questionType, gr.score)),
  }));
  return generalReviews;
};

export const generateSkillReview = (data) => {
  if (!data?.employeeSkillReviews) return [];
  const skillReviews = data.employeeSkillReviews.map((sr) => ({
    id: sr.skillID,
    title: sr.skill.name,
    score: sr.score,
    progress: generateProgress(sr.skill.skillType, sr.score),
    variant: generateVariant(generateProgress(sr.skill.skillType, sr.score)),
  }));
  return skillReviews;
};

export const exportExcel = (state, authToken, isExportRaw) => async (dispatch) => {
  const data = {
    employeeId: state.employeeId,
    periodId: state.periodId,
  };
  const response = await callApiExportExcel(data, authToken, isExportRaw);

  let successMessage = 'Excel file successfully exported';
  let errorMessage = 'Failed to export excel';
  dispatch(showAlert(response, successMessage, errorMessage));

  if (response.data) {
    const filename = response.headers['content-disposition']?.match(/filename(?:=|:)(.*)/i)?.[1].split(';')[0];
    const file = new Blob([response.data], {type: response.headers['content-type']});
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename ?? 'DefaultFilename.xls';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};

export const exportCsv = (state, authToken) => async (dispatch) => {
  const data = {
    employeeId: state.employeeId,
    periodId: state.periodId,
  };
  const response = await callApiExportCSV(data, authToken);

  let successMessage = 'CSV file successfully exported';
  let errorMessage = 'Failed to export CSV';
  dispatch(showAlert(response, successMessage, errorMessage));

  if (response.data) {
    const filename = response.headers['content-disposition']?.match(/filename(?:=|:)(.*)/i)?.[1].split(';')[0];
    const file = new Blob([response.data], {type: response.headers['content-type']});
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename ?? 'DefaultFilename.csv';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};

export const exportPdf = (data, authToken) => async (dispatch, getState) => {
  const state = getState();
  const {appState} = state;
  const newData = {
    employeeId: data.employeeId,
    periodId: data.periodId,
    authRoleID: appState.user.authRoleID,
  };
  const response = await callApiExportPdf(newData, authToken);

  let successMessage = 'PDF file successfully exported';
  let errorMessage = 'Failed to export PDF';
  dispatch(showAlert(response, successMessage, errorMessage));

  if (response.data) {
    const filename = response.headers['content-disposition']?.match(/filename(?:=|:)(.*)/i)?.[1].split(';')[0];
    const file = new Blob([response.data], {type: response.headers['content-type']});
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename ?? 'DefaultFilename.pdf';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};

export const exportPdfDetail = (data, authToken, userAuthRoleId) => async (dispatch, getState) => {
  const state = getState();
  const {appState} = state;
  const newData = {
    employeeId: data.employeeId,
    periodId: data.periodId,
    authRoleID: appState.user.authRoleID,
  };
  const response = await callApiExportPdfDetail(newData, authToken, userAuthRoleId);

  let successMessage = 'PDF Detail file successfully exported';
  let errorMessage = 'Failed to export PDF detail';
  dispatch(showAlert(response, successMessage, errorMessage));

  if (response.data) {
    const filename = response.headers['content-disposition']?.match(/filename(?:=|:)(.*)/i)?.[1].split(';')[0];
    const file = new Blob([response.data], {type: response.headers['content-type']});
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename ?? 'DefaultFilename.pdf';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};

export const importExcel = (employeeId, reviewPeriodId, file) => async (dispatch) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await consolidationApi.importExcel(employeeId, reviewPeriodId, formData);

  let successMessage = 'Consolidation has been successfully imported';
  dispatch(showAlert(response, successMessage, response.message));
  if (response.data) {
    return response.data[0];
  }
  return null;
};

export const unlockConsolidationByPeriodIdAndEmployeeId = (periodId, employeeId) => async (dispatch) => {
  const data = await consolidationApi.unlockByPeriodIdAndEmployeeId(periodId, employeeId);
  let successMessage = 'Successfully unlocked';
  let errorMessage = 'Failed to unlock';
  dispatch(showAlert(data, successMessage, errorMessage));
  return data;
};

export const getMaxScoreByQuestionType = (questionType) => {
  let maxValue = 0;
  switch (questionType) {
    case QUESTION_TYPE.SCORE_5:
      maxValue = 5;
      break;
    case QUESTION_TYPE.SCORE_10:
      maxValue = 10;
      break;
    case QUESTION_TYPE.SCORE_20:
      maxValue = 20;
      break;
    default:
      maxValue = 4;
      break;
  }
  return maxValue;
};
